import { useIntl } from '@capsicum/common';
import { useCallback } from 'react';

import { fetchAgreementVersionActive } from '../data-access';

// It retrieves the global link of the NCW terms and conditions
export const useNCWTermsAndConditions = () => {
	const { getLocalizedField } = useIntl();

	return useCallback(async (): Promise<{ link?: string }> => {
		const userAgreement = await fetchAgreementVersionActive('user_agreement_ncw');

		const link = getLocalizedField('link', userAgreement || {});

		return { link };
	}, []);
};
